import type { InnerOptions, KContext } from './types';

class Logger {
  private logger: Array<{ title: string; info: any[] }>;

  public push(title: string, ...info: any[]) {
    if (Array.isArray(this.logger)) {
      this.logger.push({ title, info });
    } else {
      this.logger = [{ title, info }];
    }
  }

  public print(options: InnerOptions, context: KContext) {
    const version = context?.['app']?.['__selfModule__']?.version;

    try {
      console.log(' ');
      console.groupCollapsed(
        `%c${options?.isMain ? '主应用' : '子应用'}执行 @kastjs/plugin-crm@${version} 插件`,
        'color: #0075ff;font-size: 14px'
      );
      this.logger.forEach(({ title, info }) => {
        console.groupCollapsed(title);
        console.log(...info);
        console.groupEnd();
      });
      console.groupEnd();
      console.log('使用指南： https://docs.corp.kuaishou.com/d/home/fcACjTztE7U0-n_wg1chhseqR');
      this.clear();
    } catch (error) {
      console.error('日志打印失败：', error);
    }
  }

  public clear() {
    this.logger = [];
  }
}

export const logger = new Logger();
